import { create } from 'zustand';
import { CareTeam } from '../../../models/CareTeam';

interface IModel {
  careTeam: CareTeam[];
  setCareTeam: (props: CareTeam[]) => void;
}

export const useCareTeam = create<IModel>(set => ({
  careTeam: [],
  setCareTeam: careTeam => set(() => ({ careTeam }))
}));
